<template>
    <div class="diff-modal">
        <div class="diff-title">{{title}}</div>
        <div class="preview">
            <div class="wanka-info">
                <wanka-info :type=false :prewInfo="wk_material" @getUrl="getWkUrl"/>
            </div>
            <div class="pk">
                <div class="icon" @click="handleShowDiff">PK</div>
            </div>
            <div class="media-info">
                <media-info :type=false :prewInfo="plat_material" @getUrl="getMediaUrl"/>
            </div>
        </div>

        <div class="mt20" style="text-align: center;">
            <div>
                <el-button v-if="status == 0 || status == 1" type="danger" plain @click="handleDiff">不同</el-button>
                <el-button v-if="status == 0 || status == 2" type="primary" @click="handleSame">相同</el-button>
            </div>
        </div>

        <SliderImg v-if="show" :imgList="pkList" @close="handleClose"/>

    </div>
</template>
<script>
import WankaInfo from '../components/wankaInfo.vue'
import MediaInfo from '../components/mediaInfo.vue'
import SliderImg from '../components/sliderImg.vue'
import { comparePreviewApi } from '@/api/systemTool/compare'
export default {
    name: 'prewModal',
    props: {
        cbs:{
            type:Object,
        },
        id: {
            type: String,
            default: ''
        },
        title: String,
        status: String
    },
    components: {
        WankaInfo,
        MediaInfo,
        SliderImg
    },
    data() {
        return {
            show: false,
            pkList:[], // 数组两项 1 比对项目 2 被比对项目 
            wid: '',
            cid: '',
            plat_id: '',
            wk_material:{},
            plat_material:{}
        }
    },
    mounted() {
        comparePreviewApi({id:this.id}).then(res=>{
            this.wk_material = res.data.wk_material
            this.plat_material = res.data.plat_material
            this.getWkUrl(this.wk_material.material_info)
            this.getMediaUrl(this.plat_material.material_info)

        }, err=>{
            this.$message.error(err.info)
        })
    },
    methods: {
        getWkUrl(params) {
            this.pkList[0] = params.material_url
            this.wid = params.wid
        },
        getMediaUrl(params) {
            this.pkList[1] = params.material_url
            this.cid = params.cid
            this.plat_id = params.plat_id
        },
        handleShowDiff() {
            if(this.pkList.length != 2) {
                return this.$message.warning('请选择对比图片')
            }
            this.show = true
        },
        handleClose() {
            this.show = false
        },
        handleSame() {
            this.cbs.onSame()
        },
        handleDiff() {
            this.cbs.onDiff()
        }
    }
}
</script>
<style lang="scss" scoped>
.diff-modal {
    width: 100%;
    position: relative;
    .diff-title {
        position: absolute;
        top: -63px;
        left: 76px;
        font-size: 14px;
    }
    .preview {
        max-height: 60vh;
        overflow-y: auto;
        display: flex;
        justify-content: space-between;
        position: relative;

        .wanka-info {
            // flex: 1;
            width: 47%;
        }

        .media-info {
            // flex: 1;
            width: 47%;
        }

        .pk {
            width: 6%;
            padding: 0 10px;
            text-align: center;
            padding-top: 20vh;
            

            .icon {
                cursor: pointer;
                border: 3px solid #66b1ff;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                line-height: 36px;
                color: #66b1ff;
            }

        }
    }

}
</style>